import { registerModule, runWhenPlatformInitialized, ltjsModule } from '@sas-dvr/ltjs-commons/ltjsEnvironment';
import GTLFoundationPackage from './GTLFoundationPackage';
import '@sas-dvr/ltjs-sasicu/lib';
// needed for sas/ltjs/commons/ui/tooltip/TooltipManager
import './models/LabelValuePickResultDetails';
// needed for Time based tips. Used in VisualizationManager
import './models/core/TimePickResultDetails';
import { setStackedWebmapDisplay } from "@sas-dvr/ltjs-commons/InjectedStackedWebmapDisplay";
import StackedWebmapDisplay from './webmap/StackedWebmapDisplay';
registerModule('gtl', [GTLFoundationPackage]);
// Inject gtl-aware stacked webmap display provider for use by
// VisualizationManager.
setStackedWebmapDisplay(StackedWebmapDisplay);
runWhenPlatformInitialized(function (platformInitCallback) {
    ltjsModule.module._ltjs_gtl_GraphPlatformUtilities_initializeGraphDefaults();
    if (platformInitCallback) {
        platformInitCallback();
    }
}, true);
